module.exports = __webpack_public_path__ + "static/media/photo_alternative_energy.0b2033a4.jpg";